<ng-template #drawerTemplate>
  <div class="drawer-container" [@slideUpDown]="isOpen() ? 'open' : 'closed'">
    <div class="drawer-header">
      <h2 class="drawer-title">{{ 'common.action.my_account' | translate }}</h2>
      <button type="button" class="close-button" (click)="close()" aria-label="Close drawer">
        <app-icon name="X" size="lg" />
      </button>
    </div>

    <div class="drawer-content">
      <app-account-side-navigation />
    </div>
  </div>
</ng-template>

